import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './locals/en/translation.json';
import { componentTranslations } from 'vopay';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translations: translationEn,
        components: componentTranslations.en,
      },
    },
    detection: {
      order: ['localStorage', 'sessionStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

export default i18n;
